<template>
  <v-col class="ma-2" cols="12" md="8">
    <v-expansion-panels dense class="" elevation="4" inset outlined>
      <!-- <v-expansion-panel>
        <v-expansion-panel-header @click="getRiskscore(BusOnboardcode)">
          <p class="ma-0 pa-0 font-weight-bold">
            <v-icon class="pe-2 pb-2">mdi-account-group-outline</v-icon>Onboard
            Risk Table
          </p>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table fixed-header  height="55vh"
            :headers="headers"
            hide-default-footer
            :items="BusonboardItems"
          >
            <template v-slot:[`item.score`]="{ item }">
              {{ item.min_risk_score }} -{{ item.max_risk_score }}
            </template>
            <template v-slot:[`item.risk_status`]="{ item }">
              <span
                :class="[getClassByRiskStatus(item.risk_status), 'green-cell']"
                >{{ item.risk_status }}</span
              >
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel> -->
      <v-expansion-panel>
        <v-expansion-panel-header @click="getRiskscore(BusTranscationcode)">
          <p class="ma-0 pa-0 font-weight-bold">
            <v-icon class="pe-2 pb-2"
              >mdi-briefcase-arrow-left-right-outline</v-icon
            >Transaction Risk Table
          </p>
          <!-- <v-btn depressed  text plain small> View Details </v-btn> -->
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table fixed-header  height="55vh"
            :headers="headers"
            hide-default-footer
            :items="BustransItems"
          >
            <template v-slot:[`item.score`]="{ item }">
              {{ item.min_risk_score }} -{{ item.max_risk_score }}
            </template>
            <template v-slot:[`item.risk_status`]="{ item }">
              <span
                :class="[getClassByRiskStatus(item.risk_status), 'green-cell']"
                >{{ item.risk_status }}</span
              >
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
import setupService from "@/services/SetupService/setupService.js";

export default {
  data: () => ({
    headers: [
      {
        text: "Risk Status ",
        align: "start",
        sortable: false,
        value: "risk_status",
      },
      { text: "Risk Score", value: "score", sortable: false },
      { text: "Percentage", value: "perentage", sortable: false },
      { text: "Control & Mitigation", value: "control", sortable: false },
      {
        text: "Reporting Frequency",
        value: "reporting_sequence",
        sortable: false,
      },
    ],
    BusonboardItems: [],
    BustransItems: [],
    BusOnboardcode: "IOR",
    BusTranscationcode: "ITR",
  }),
  methods: {
    async getRiskscore(BusOnboardcode) {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getRiskscore(BusOnboardcode);
        if (response.data.status_code === 200) {
          switch (BusOnboardcode) {
            case "IOR":
              console.log("IOR codes", response.data.data);
              this.BusonboardItems = response.data.data;
              console.log("response", response);
              break;
            case "ITR":
              console.log("ITR codes", response.data.data);
              this.BustransItems = response.data.data;
              break;
          }
        }
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getRiskscore(BusOnboardcode);
        // }
      } catch (error) {
        this.transItems = [];

        console.error(error);
      }
    },
    getClassByRiskStatus(risk_status) {
      if (risk_status === "Low") {
        return "success--text";
      } else if (risk_status === "Medium") {
        return "orange--text";
      } else if (risk_status === "High") {
        return "red--text";
      }

      return "";
    },
  },
};
</script>

<style scoped></style>
